import * as actions from './vendorPayment/actions'
import * as mutations from './vendorPayment/mutations'
import * as getters from './vendorPayment/getters'

import { dataProps } from './vendorPayment/properties'

const state = {
    list: [],
    settlement_type: 1,
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'id',
        sort_direction: 1, search_term: '', 
search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorPayment.js